module.exports = __webpack_public_path__ + "img/logo.44c91925.png";